// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__79JF5","box":"WorkspacesBox_box__2VRgr","node":"WorkspacesBox_node__3tApk"};